import type { Predicate } from './types';

export const some =
    <T>(predicates: Predicate<T>[]): Predicate<T> =>
    (candidate) =>
        predicates.some((predicate) => predicate(candidate));
